<template>
  <vx-card title="Inaktive Stammkunden">
    <p class="text-sm text-grey mb-4">
      Kunden mit mind. 5 Bestellungen, die seit über 5 Monaten nicht bestellt
      haben.
    </p>
    <div v-if="loading" class="flex items-center justify-center py-8">
      <span class="text-grey">Wird geladen...</span>
    </div>
    <div v-else-if="customers.length === 0" class="py-4 text-grey">
      Keine inaktiven Stammkunden gefunden.
    </div>
    <vs-table v-else :data="customers" stripe>
      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="phone">Telefon</vs-th>
        <vs-th sort-key="totalOrders">Bestellungen</vs-th>
        <vs-th sort-key="totalRevenue">Umsatz</vs-th>
        <vs-th sort-key="daysSinceLastOrder">Inaktiv seit</vs-th>
        <vs-th sort-key="lastOrderDate">Letzte Bestellung</vs-th>
        <vs-th>Adresse</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="(customer, index) in data" :key="index">
          <vs-td>{{ customer.name }}</vs-td>
          <vs-td>{{ customer.phone }}</vs-td>
          <vs-td>{{ customer.totalOrders }}</vs-td>
          <vs-td
            >{{
              customer.totalRevenue.toLocaleString("de-DE", {
                minimumFractionDigits: 2,
              })
            }}
            €</vs-td
          >
          <vs-td>
            <vs-chip :color="getInactiveColor(customer.daysSinceLastOrder)">
              {{ customer.daysSinceLastOrder }} Tage
            </vs-chip>
          </vs-td>
          <vs-td>{{ formatDate(customer.lastOrderDate) }}</vs-td>
          <vs-td>
            <vs-button
              v-if="customer.lastAddress"
              size="small"
              type="filled"
              color="primary"
              icon-pack="feather"
              icon="icon-info"
              @click="showAddress(customer)"
            />
            <span v-else class="text-grey text-xs">–</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup
      v-if="selectedCustomer"
      title="Letzte Adresse"
      :active.sync="addressPopup"
    >
      <div v-if="selectedCustomer.lastAddress">
        <p class="font-bold">{{ selectedCustomer.name }}</p>
        <p class="mt-2">
          {{ selectedCustomer.lastAddress.street }}
          {{ selectedCustomer.lastAddress.streetNumber }}
        </p>
        <p>
          {{ selectedCustomer.lastAddress.zipCode }}
          {{ selectedCustomer.lastAddress.city }}
        </p>
        <p v-if="selectedCustomer.phone" class="mt-2 text-grey">
          Tel: {{ selectedCustomer.phone }}
        </p>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import axios from "@/axios.js";

export default {
  name: "AnalyticsChurnedCustomers",
  data() {
    return {
      customers: [],
      loading: true,
      addressPopup: false,
      selectedCustomer: null,
    };
  },
  async created() {
    try {
      const res = await axios.get("/api/analytics/churned-customers");
      this.customers = res.data.data;
    } catch (error) {
      console.log(error);
    }
    this.loading = false;
  },
  methods: {
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    showAddress(customer) {
      this.selectedCustomer = customer;
      this.addressPopup = true;
    },
    getInactiveColor(days) {
      if (days > 365) return "danger";
      if (days > 270) return "warning";
      return "primary";
    },
  },
};
</script>
